var map = {
	"./Race_Antuk.png": 531,
	"./Race_Krakee.png": 532,
	"./Race_Mantah.png": 533,
	"./Race_Montak.png": 534,
	"./Race_Muu.png": 535,
	"./Race_None.png": 536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 273;